import React from 'react';
import { catColor } from '../../helpers';

const SHORT_MAP = { 'Mean Reversion': 'MR', 'Trend': 'TR', 'Hybrid': 'HY' };

export default function CategoryBadge({ category }) {
  if (!category) return null;
  const c = catColor(category);
  return (
    <span title={category} className="badge" style={{
      background: `${c}18`,
      border:     `1px solid ${c}40`,
      color:      c,
      fontSize:   9,
      letterSpacing: '0.06em',
    }}>
      {SHORT_MAP[category] || category.slice(0, 2).toUpperCase()}
    </span>
  );
}
